export default "__VITE_ASSET__556a8cc4__"